import { render, staticRenderFns } from "./banner-boost.vue?vue&type=template&id=50bed80d&"
import script from "./banner-boost.vue?vue&type=script&lang=js&"
export * from "./banner-boost.vue?vue&type=script&lang=js&"
import style0 from "./banner-boost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports